const { getEncryptedCreditCardData } = require('utils/CreditCard');
const ufeApi = require('services/api/ufeApi');

// https://confluence.sephora.com/wiki/display/ILLUMINATE/Add+Payment+Credit+Card+API
function addPaymentCreditCard(creditCardData) {
    const url = '/api/payments/creditCard';
    const encryptedCreditCardData = getEncryptedCreditCardData(creditCardData);

    if (encryptedCreditCardData.errorCode === -1) {
        return Promise.reject(encryptedCreditCardData);
    }

    return ufeApi
        .makeRequest(url, {
            method: 'POST',
            body: JSON.stringify(encryptedCreditCardData)
        })
        .then(data => (data.errorCode ? Promise.reject(data) : data));
}

module.exports = addPaymentCreditCard;
